import { Header, Section, Title } from './FilterBy.styles';
import { assocPath, contains } from 'ramda';
import { FilterByPropsType } from './FilterBy';
import { FilterOptionType } from 'utils/filters/requests.filters';
import React from 'react';
import Select from '../../common/Select';
import { withTranslation } from 'react-i18next';

const OPTION = 'EMAILS';

const FilterEmails = ({
  data: {
    filterBy,
    filterOptions: { EMAILS },
    isSent,
  },
  actions: { setFilter },
  t,
}: FilterByPropsType) => {
  const handleChange = (newEmails: FilterOptionType[]) => {
    const lookFor = newEmails.map(data => data.value);
    const isEnabled = lookFor.length > 0;

    setFilter(assocPath([OPTION], { isEnabled, lookFor }, filterBy));
  };

  const initialValue = EMAILS!.filter(item =>
    contains(item.value, filterBy.EMAILS.lookFor || []),
  );

  return (
    <Section>
      <Header>
        <Title>{t(`Requests.filterOptions.${OPTION}`) as string}</Title>
      </Header>
      <div data-test="filter-dropdown">
        <Select
          defaultValue={initialValue}
          isMulti
          onChange={handleChange}
          options={EMAILS}
          placeholder={t('Requests.addEmailsToFilter')}
        />
      </div>
    </Section>
  );
};

export default withTranslation()(FilterEmails);
